module.exports = __webpack_public_path__ + "static/img/bg.d2b8aa82.jpg";